import http from './axios';

export default class MyDoneServices {
  private readonly info_api = '/v1/mydone/info'; //
  private readonly doneHandleCount_api = '/v1/mydone/done-handle-count'; // 我的已办经办预总览
  private readonly doneReviewCount_api = '/v1/mydone/done-review-count'; // 我的已办复核总览
  private readonly doneApproveCount_api = '/v1/approverecord/done-app-count'; // 已办审批总览
  private readonly doneReqCount_api = '/v1/approverecord/done-req-count'; // 已提交申请总览
  private readonly doneHandlePage_api = '/v1/mydone/done-handle-page'; // 已办经办预警列表查询
  private readonly doneReviewPage_api = '/v1/mydone/done-review-page'; // 已办复核预警列表查询
  private readonly doneApprovePage_api = '/v1/approverecord/done-app-page'; // 我的已办审批列表查询
  private readonly doneReqPage_api = '/v1/approverecord/done-req-page'; // 我的已提交申请列表查询
  private readonly recall_api = '/v1/approverecord/recall'; // 撤回
  private readonly processHandleAlert_api = '/v1/mydone/process-handle-alert'; // 经办/忽略/转办预警
  private readonly processReviewAlert_api = '/v1/mydone/process-review-alert'; // 驳回/忽略/复核预警

  constructor() {}

  async getInfo(alertCode: string) {
    let res: any = await http.get(this.info_api, { params: { alertCode } });
    return res.payload;
  }
  // 我的已办经办预总览
  async getHandleCount(params?: object): Promise<any> {
    let res: any = await http.get(this.doneHandleCount_api, { params: params });
    return res.payload;
  }
  // 已办经办预警列表查询
  async getHandlePage(params?: object): Promise<any> {
    let res: any = await http.get(this.doneHandlePage_api, { params: params });
    return res.payload;
  }
  // 经办/忽略/转办预警
  async processHandleAlert(params: any) {
    let res: any = await http.post(this.processHandleAlert_api, params);
    return res.header?.code == 200 ? true : false;
  }

  // 我的已办复核总览
  async getReviewCount(params?: object): Promise<any> {
    let res: any = await http.get(this.doneReviewCount_api, { params: params });
    return res.payload;
  }
  // 我的已办复核预警列表查询
  async getReviewPage(params?: object): Promise<any> {
    let res: any = await http.get(this.doneReviewPage_api, { params: params });
    return res.payload;
  }
  // 驳回/忽略/复核预警
  async processReviewAlert(params: any) {
    let res: any = await http.post(this.processReviewAlert_api, params);
    return res.header?.code == 200 ? true : false;
  }

  // 已办审批总览
  async getApproveCount(params?: object): Promise<any> {
    let res: any = await http.get(this.doneApproveCount_api, { params: params });
    return res.payload;
  }
  // 我的已办审批预警列表查询
  async getApprovePage(params?: object): Promise<any> {
    let res: any = await http.get(this.doneApprovePage_api, { params: params });
    return res.payload;
  }

  // 已提交申请总览
  async getReqCount(params?: object): Promise<any> {
    let res: any = await http.get(this.doneReqCount_api, { params: params });
    return res.payload;
  }
  // 我的已提交申请列表查询
  async getReqPage(params?: object): Promise<any> {
    let res: any = await http.get(this.doneReqPage_api, { params: params });
    return res.payload;
  }

  async recall(params?: object): Promise<any> {
    let res: any = await http.post(this.recall_api, params);
    return res.header?.code == 200 ? true : false;
  }
  
}
